<style lang="less" scoped>
  @import "../../vars.less";

  .gesture-login {
    background-color: #fff;
  }
  .container {
    position: absolute;
    width: 100%;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .header {
    position: relative;
    z-index: 1;
  }
  .welcome {
    margin: @space-large * 2 0 0 0;
    font-size: 16px;
    text-align: center;
    color: @text-color;
  }
  .placeholder {
    margin: @space-small 0 0 0;
    text-align: center;
    font-size: 14px;
    color: @text-color-secondary;
  }
  .gesture-password-container {
    flex: none;
    position: relative;
    top: -20px;
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .retry-count {
    position: relative;
    top: -50px;
    font-size: 14px;
    color: @text-color-secondary;
    text-align: center;
  }
  .tips {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: @space-normal;
    font-size: 14px;
    color: @text-color-secondary;
  }
</style>

<template>
  <page-container class="gesture-login" :loading="loading">
    <div slot="header"></div>
    <div class="container">
      <div class="header">
        <h3 class="welcome">{{ $t('欢迎回来') }}</h3>
        <p class="placeholder">{{ $t('请输入手势密码') }}</p>
      </div>
      <div class="gesture-password-container" @touchmove.stop.prevent>
        <gesture-password :width="width" :height="width"
          lineColor="#009999"
          lineBackground="#9aecec"
          @onChange="onChange"></gesture-password>
      </div>
      <p class="retry-count">
        {{ $t('您还可以尝试次', { count: retryCount }) }}
      </p>
    </div>
    <div class="tips" slot="footer">
      <span class="tip" @click="forget">{{ $t('忘记手势密码') }}</span>
      <span class="tip" @click="toggle">{{ $t('切换登录') }}</span>
    </div>
  </page-container>
</template>

<script>
import { Notify } from 'vant'
import GesturePassword from '@alitajs/gesture-password-vue'
import PageContainer from '../../components/PageContainer'
import { DEFAULT_GESTURE_RETRY_COUNT, LS_KEYS } from '../../constants'
import { decrypt } from '../../utils/crypto'
import ls from '../../utils/local-storage'

export default {
  name: 'gesture-login',
  components: {
    GesturePassword,
    PageContainer
  },
  data () {
    return {
      width: 1000,
      loading: false,
      retryCount: ls.get(LS_KEYS.GESTURE_RETRY_COUNT) || DEFAULT_GESTURE_RETRY_COUNT
    }
  },
  watch: {
    retryCount (v) {
      ls.set(LS_KEYS.GESTURE_RETRY_COUNT, v)
      if (Number(v) === 0) {
        // current gesture is out of date
        // need to reset it again
        ls.remove(LS_KEYS.GESTURE_RETRY_COUNT)
        ls.remove(LS_KEYS.ACCOUNT)
        ls.remove(LS_KEYS.ENCRYPTED_PWD)
        this.toggle()
      }
    }
  },
  computed: {
    isRetryOut () {
      return Number(this.retryCount) === 0
    }
  },
  methods: {
    onChange (numbers) {
      if (numbers.length < 5) {
        Notify({ type: 'warning', message: this.$t('手势密码错误，请重新输入') })
        this.retryCount = this.retryCount - 1
        return
      }
      this.loading = true
      const encryptedPwd = ls.get(LS_KEYS.ENCRYPTED_PWD)
      const password = decrypt(numbers, encryptedPwd)
      const username = ls.get(LS_KEYS.ACCOUNT)
      this.$apis.auth.normalLogin(
        username,
        password,
        loading => (this.loading = loading),
        error => {
          if (error.ErrorCode === '402') { // username or password error
            this.retryCount = this.isRetryOut ? 0 : this.retryCount - 1
          }
          return true
        }
      ).then(this.onLoginSuccess)
    },
    onLoginSuccess (res) {
      if (res && res.pgt) {
        // save pgt
        ls.set(LS_KEYS.PGT, res.pgt)
        // save username to use gesture pwd
        ls.set(LS_KEYS.ACCOUNT, res.userInfo?.account)
        ls.set(LS_KEYS.EMAIL, res.userInfo?.email)
        // save all userinfo
        ls.set(LS_KEYS.USERINFO, JSON.stringify(res.userInfo))
        // save authorization
        ls.set(LS_KEYS.AUTHORIZATION, JSON.stringify(res.authForAllOp))
        // reset retry count
        this.retryCount = DEFAULT_GESTURE_RETRY_COUNT
        if (res.modify_pwd) {
          ls.set(LS_KEYS.NEED_MODIFY_PWD, true)
          this.$nextTick(() => this.$router.push({ name: 'change-password' }))
        } else {
          ls.set(LS_KEYS.NEED_MODIFY_PWD, false)
          this.$nextTick(() => this.$router.push({ name: 'home' }))
        }
      }
    },
    toggle () {
      this.$router.push({ name: 'login' })
    },
    forget () {
      ls.remove(LS_KEYS.NO_LOGNGER_SHOW_GESTURE_TIPS)
      ls.remove(LS_KEYS.ENCRYPTED_PWD)
      this.toggle()
    }
  },
  mounted () {
    if (
      !ls.get(LS_KEYS.ACCOUNT) ||
      !ls.get(LS_KEYS.ENCRYPTED_PWD)
    ) {
      Notify({ type: 'warning', message: this.$t('未登陆，请重新登陆') })
      this.toggle()
    } else {
      if (this.isRetryOut) {
        this.toggle()
      }
    }
  }
}
</script>
